<div class="cancel-subscription-modal">
  <button
    type="button"
    class="button-undecorated cancel-close-button"
    [attr.aria-label]="translationRoot + '.close' | transloco"
    (click)="closeModal()"
  >
    <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
  </button>

  <h2 class="cancel-title">{{ translationRoot + '.title' | transloco }}</h2>

  @if (showSavings()) {
    <p class="cancel-savings">
      <strong>{{ translationRoot + '.savings.first' | transloco: { amount: savedAmount() } }}</strong>
      {{ translationRoot + '.savings.second' | transloco }}
    </p>
  }

  <img class="cancel-artwork" [src]="'assets/icons/cancelation-modal.svg' | deployUrl" alt="" />

  <p class="cancel-price">
    {{ translationRoot + '.price.first' | transloco }}
    <strong>{{ price() }}</strong>{{ translationRoot + '.price.second' | transloco }}
  </p>

  @if (allErrors.length) {
    <div class="generic-errors" role="alert">
      @for (error of allErrors; track $index) {
        <span class="error"><cwo-icon class="icon" [name]="iconNameType.error" />{{ error }}</span>
      }
    </div>
  }

  <div class="cancel-actions">
    <button type="button" class="button-accent cancel-keep-button" (click)="closeModal()">
      {{ translationRoot + '.keep' | transloco }}
    </button>

    <button
      type="button"
      cwoAsyncButton
      class="button-accent-secondary cancel-confirm-button"
      [subscription]="loadingSubscription"
      [attr.aria-busy]="!!loadingSubscription"
      (click)="cancelSubscription()"
    >
      {{ translationRoot + '.cancel' | transloco }}
    </button>
  </div>

  <p class="cancel-rejoin">{{ translationRoot + '.rejoin' | transloco }}</p>
</div>
